import React from 'react';

import { bemBlock } from '../../modules/bem';

import { useEmblemContext } from './EmblemContext';

import './EmblemWrapper.less';

const block = bemBlock('n-emblem-wrapper');

type EmblemWrapperProps = {
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  onDoubleClick?: React.MouseEventHandler<HTMLElement>;
  color?: 'plain' | 'info' | 'warning' | 'error' | 'success' | 'accent' | string;
  role?: React.AriaRole;
  'aria-label'?: string;
  'data-role'?: string;
  'data-id'?: string;
  width?: number | 'auto';
};

const COLOR_ALIASES = new Set(['plain', 'info', 'warning', 'error', 'success', 'accent']);

export const EmblemWrapper: React.FC<EmblemWrapperProps> = ({
  className,
  children,
  color,
  onClick,
  onDoubleClick,
  role,
  'aria-label': ariaLabel,
  'data-role': dataRole,
  'data-id': dataId,
  width,
}) => {
  const { variant, size, active } = useEmblemContext();

  const cssClass = block({
    extra: className,
    modifiers: {
      size,
      variant,
      active,
      clickable: Boolean(onClick),
      ...(color && { [color]: COLOR_ALIASES.has(color) }),
    },
  });

  return (
    <div
      style={{ color, width, maxWidth: width ? 'none' : undefined }}
      role={role}
      aria-label={ariaLabel}
      data-role={dataRole}
      data-id={dataId}
      className={cssClass}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      {children}
    </div>
  );
};
